import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import Button from '../../../../components/Button';
import lkflModal from '../../../../services/lkflModal';
import AutoTopupModal from './AutoTopupModal';
import { fromJS } from 'immutable';
import AutoTopupInfo from './AutoTopupInfo';
import AutoTopupDisableModal from './AutoTopupDisableModal';
import { apiResponseWrapper } from '../../../../utils/apiResponseWrapper';
import { useQuery } from 'react-query';
import Loading from '../../../../components/Loading';
import { getAutoTopup, setAutoTopup } from './API/api';
import { addDays, format, isBefore, parseISO } from 'date-fns';
import { keys, set } from 'lodash';
import { ErrorType } from 'api/mmServerApi';
import { SubmissionError } from 'redux-form/es';
import config from 'config';

function AutoTopupBlock({ bankCards }) {
  const fromDate = format(addDays(new Date(), 1), 'yyyy-MM-dd');
  const initialState = {
    activityRange: [fromDate, ''],
  };

  useEffect(() => {
    return () => {
      lkflModal.hide();
    };
  }, []);

  const [autoTopUpInfo, setAutoTopUpInfo] = useState(initialState);
  const { data, isFetching } = useQuery('getAutoTopUp', async () => {
    const res = await getAutoTopup();
    return apiResponseWrapper(res);
  });

  const onSubmitHandle = async (formData, onConfirm) => {
    try {
      apiResponseWrapper(await setAutoTopup(formData.toJS()));
      onConfirm(formData.toJS());
    } catch (error) {
      const { errorType, fieldErrors } = error;
      if (errorType === ErrorType.VALIDATIONERROR) {
        const validationErrors = {};
        keys(fieldErrors).map((fieldName) => {
          set(validationErrors, fieldName, fieldErrors[fieldName]);
        });
        throw new SubmissionError(validationErrors);
      }
    }
  };

  useEffect(() => {
    if (data?.amount) {
      setAutoTopUpInfo(data);
    }
  }, [data]);

  // check startDate is not before tomorrow
  const updateInitialValues = useMemo(() => {
    const { activityRange } = autoTopUpInfo;
    if (isBefore(parseISO(activityRange[0]), parseISO(fromDate))) {
      return fromJS({
        ...autoTopUpInfo,
        activityRange: initialState.activityRange,
      });
    }
    return fromJS(autoTopUpInfo);
  }, [autoTopUpInfo]);

  const onTopUpClick = async () => {
    const res = await lkflModal.show({
      //eslint-disable-next-line
      content: (onConfirm, onReject) => {
        return (
          <AutoTopupModal
            bankCards={bankCards}
            initialValues={updateInitialValues}
            onSubmit={(formData) => onSubmitHandle(formData, onConfirm)}
            onReject={onReject}
            onConfirm={onConfirm}
          />
        );
      },
    });
    setAutoTopUpInfo(res);
  };

  const onDisableTopupClick = async () => {
    await lkflModal.show({
      //eslint-disable-next-line
      content: (onConfirm, onReject) => {
        return <AutoTopupDisableModal onReject={onReject} onConfirm={onConfirm} />;
      },
    });
    setAutoTopUpInfo(initialState);
  };
  return isFetching ? (
    <Loading />
  ) : (
    <div className={'boo'}>
      <div className={'H2 pb-3 pt-4 border-top'}>Автоматическое пополнение кошелька</div>
      <div className={'mb-3'}>
        Подключите ежемесячное автопополнение ЕНП. ЕНП — это электронный кошелек налогоплательщика,
        куда он может вносить деньги для последующей уплаты налогов и задолженности по ним. Зачет
        платежа налоговые органы проводят самостоятельно не позднее 10 дней со дня направления
        сводного налогового уведомления. Остаток сохранится в электронном кошельке до наступления
        следующего срока уплаты. Вы в любой момент можете отключить автоматическое пополнение
        кошелька
      </div>

      {!!autoTopUpInfo?.amount ? (
        <AutoTopupInfo
          onTopUpClick={onTopUpClick}
          onDisableTopupClick={onDisableTopupClick}
          topupInfo={autoTopUpInfo}
          bankCards={bankCards}
        />
      ) : (
        !config.isInspectorArm && <Button onClick={onTopUpClick}>Подключить автопополнение</Button>
      )}
    </div>
  );
}

export default AutoTopupBlock;

AutoTopupBlock.propTypes = {
  bankCards: PropTypes.any,
};
